import { render } from "./ViewUsers.vue?vue&type=template&id=1b47588c&scoped=true&ts=true"
import script from "./ViewUsers.vue?vue&type=script&lang=ts"
export * from "./ViewUsers.vue?vue&type=script&lang=ts"

import "./ViewUsers.vue?vue&type=style&index=0&id=1b47588c&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b47588c"]])

export default __exports__